import './MaintenancePage.css';
import logo from '../images/logo.png';

const MaintenancePage = () => {
  return (
    <div className="maintenance-container">
      <img src={logo} alt="Cocoparks Logo" className="maintenance-logo" />
      <h1 className="maintenance-title">🚧 Mise à jour en cours</h1>
      <p className="maintenance-message">
        Nous améliorons l'application Cocoparks.<br />
        Merci de revenir dans quelques instants.
      </p>
    </div>
  );
};

export default MaintenancePage;
